import type { ReceiptTemplate } from '../schema';

export const cleartaxTemplate: ReceiptTemplate = {
  id: 'cleartax',
  name: 'ClearTax Receipt',
  brand: 'CLEARTAX',
  description: 'ClearTax service receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '₹',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ct-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'CLEARTAX',
        businessNameFontSize: 18,
        addressLines: ['TAX FILING RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ct-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'CT-847291034' },
          { id: 'user', label: 'User:', value: 'john@email.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'fy', label: 'FY:', value: '2025-26' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ct-service',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'SERVICE: ITR Filing\nPLAN: Expert Assisted\nACK NO: ITR-847291034567', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'ct-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'service', label: 'SERVICE FEE', value: '1,499', isBold: false, isLarge: false },
          { id: 'gst', label: 'GST (18%)', value: '270', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1,769', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ct-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'UPI', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'ct-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'FILING SUCCESSFUL\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

